import { useEffect, useLayoutEffect } from 'react';
/**
 * Checks if the code is running on the client-side.
 * @returns {boolean} Returns true if the code is running on the client-side, false otherwise.
 */
const isClient = () => typeof window !== 'undefined';
/**
 * A hook that uses `useLayoutEffect` on the client-side and `useEffect` on the server-side.
 * @returns {Function} The hook to use.
 */
export const useUniversalLayoutEffect = isClient() ? useLayoutEffect : useEffect;
